<template>
    <div class="row">
        <div class="col-md-4">
            <config-list
                    :items="items"
                    :activeItem="activeItem"
                    :editMode="editMode"
                    @active-item-changed="changeActiveItem"
                    @create-item="createItem"
            ></config-list>
        </div>
        <div class="col-md-8">
            <config-item
                    
                    :item="activeItem"
                    :editMode="editMode"
                    @refresh="reloadItems"
            ></config-item>
        </div>
    </div>
</template>

<script>
    import ConfigList from './ConfigList'
    import ConfigItem from './ConfigItem'

    export default {
        name: "config-manager",

        components: {
            ConfigList,
            ConfigItem
        },

        props: {
            items: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                activeItem: null,
                editMode: false
            }
        },

        methods: {
            changeActiveItem({item, editMode}) {
                this.activeItem = item
                this.editMode = editMode
            },

            createItem() {
                this.activeItem = null
                this.editMode = true
            },

            async reloadItems() {
                try {
                    let response = await axios.get(Sincron.routes.route('config.index'))
                    this.items = response.data.items

                } catch (error) {
                    console.log(error)
                }
            }
        }
    }
</script>

<style scoped>

</style>